import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=50369d86"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50369d86')) {
      api.createRecord('50369d86', component.options)
    } else {
      api.reload('50369d86', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=50369d86", function () {
      api.rerender('50369d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/documentConfiguration/Main.vue"
export default component.exports